import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_upload_outlined = _resolveComponent("upload-outlined");
  const _component_a_button = _resolveComponent("a-button");
  const _component_a_space = _resolveComponent("a-space");
  const _component_a_upload = _resolveComponent("a-upload");
  return _openBlock(), _createBlock(_component_a_upload, {
    "file-list": $setup.fileList,
    "onUpdate:fileList": _cache[0] || (_cache[0] = $event => $setup.fileList = $event),
    customRequest: $setup.customRequest,
    action: $setup.actionUrl,
    name: $props.name,
    data: $setup.postData,
    headers: $setup.postHeaders,
    accept: $props.accept,
    "show-upload-list": $props.showUploadList,
    "before-upload": $setup.beforeUpload,
    onChange: $setup.handleChange,
    onRemove: $setup.handleRemove,
    onPreview: $setup.handlePreview,
    onDownload: $setup.handleDownload,
    multiple: $props.multiple,
    directory: $props.directory
  }, {
    itemRender: _withCtx(({
      file,
      actions,
      ...more
    }) => [_renderSlot(_ctx.$slots, "itemRender", _normalizeProps(_guardReactiveProps({
      file,
      actions,
      ...more
    })), () => [_createVNode(_component_a_space, null, {
      default: _withCtx(() => [_createElementVNode("span", {
        style: _normalizeStyle(file.status === 'error' ? 'color: red' : '')
      }, [file.status === 'error' ? (_openBlock(), _createElementBlock("span", _hoisted_1, "[" + _toDisplayString(file.error) + "]", 1)) : _createCommentVNode("", true), _createTextVNode(_toDisplayString(file.name), 1)], 4), _createElementVNode("a", {
        href: "javascript:void(0);",
        onClick: actions.preview
      }, "打开", 8, _hoisted_2), _createElementVNode("a", {
        href: "javascript:void(0);",
        onClick: actions.download
      }, "下载", 8, _hoisted_3), _createElementVNode("a", {
        href: "javascript:void(0);",
        onClick: actions.remove
      }, "删除", 8, _hoisted_4)]),
      _: 2
    }, 1024)])]),
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {
      loading: $setup.loading,
      canUpload: $setup.canUpload
    }, () => [$setup.canUpload ? (_openBlock(), _createBlock(_component_a_button, {
      key: 0,
      loading: $setup.loading
    }, {
      default: _withCtx(() => [_createVNode(_component_upload_outlined), _createTextVNode(" " + _toDisplayString($props.title), 1)]),
      _: 1
    }, 8, ["loading"])) : _createCommentVNode("", true)])]),
    _: 3
  }, 8, ["file-list", "customRequest", "action", "name", "data", "headers", "accept", "show-upload-list", "before-upload", "onChange", "onRemove", "onPreview", "onDownload", "multiple", "directory"]);
}